import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { IEpGridModel } from '@epicor/kinetic';
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-address-info-map-card',
  templateUrl: './epbt-fa-address-info-map-card.component.html',
  styleUrls: ['./epbt-fa-address-info-map-card.component.scss']
})
export class EpbtFaAddressInfoMapCardComponent implements OnInit {

  @Input() mapCardModel: IEpGridModel;
  bodyTemplate: TemplateRef<any>;
  headerTemplate: TemplateRef<any>;

  @Input() model: IEpGridModel;
  constructor() { }

  ngOnInit() {
  }
}
